<template>
  <div id="amoutSelector">
    <h3>Выберите сумму транша</h3>
    <div class="amountLine frln">
      <p>Выберите сумму</p>
      <p>{{ paymentInfo.Amount | moneyFormat }} ₽</p>
    </div>
    <range-slider
      class="slider"
      :min="rangeMin"
      :max="rangeMax"
      :step="rangeStep"
      v-model="rangeValue">
    </range-slider>
    <div class="amountLine clgra">
      <p>от {{ rangeMin | moneyFormat }} ₽</p>
      <p>до {{ rangeMax | moneyFormat }} ₽</p>
    </div>
    <div class="amountLine clgr">
      <p>Вы получите:</p>
      <p>{{ paymentInfo.Amount | moneyFormat }} ₽</p>
    </div>
    <div class="amountLine clgr">
      <p>На срок:</p>
      <p>{{ paymentInfo.Period }} {{ paymentInfo.PeriodType}}</p>
    </div>
    <div class="amountLine clgr">
      <p>Платеж:</p>
      <p>{{ paymentInfo.FixedPay | moneyFormat }} ₽ в неделю</p>
    </div>
    <div class="amountLine clgr">
      <p>Ставка:</p>
      <p>{{ paymentInfo.PercentageRate }}% годовых</p>
    </div>
    <div class="amountLine clgr">
      <p>К возврату:</p>
      <p>{{ paymentInfo.OutPayments | moneyFormat }} ₽</p>
    </div>
    <button v-on:click="goTo('formWrap', $event)" class="instButton">Получить деньги</button>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import "@/assets/css/variable.css";
import "@/assets/css/fontRoboto.css";
import RangeSlider from "vue-range-slider";
import 'vue-range-slider/dist/vue-range-slider.css'
export default {
  name: "instAmountSelector",
  components: {
    RangeSlider
  },
  computed: {
    ...mapState({
      rangeMin: state => state.Deal.minBaseProduct.Amount,
      rangeMax: state => state.Deal.MaxSumm,
      rangeStep: state => state.Deal.StepSumm,
      summVuex: state => state.Deal.SelectedSumm,
    }),
    ...mapGetters(['paymentInfo','FixedPay']),
    rangeValue: {
      get() {
        return this.summVuex;
      },
      set(value) {
        let saveSumm = this.summVuex;
        this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: value});
        this.$store.dispatch('saveSendData', {target: 'CALC_SUMM', value: value});
        if (this.FixedPay ==0 ) {
          this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: saveSumm});
          this.$store.dispatch('saveSendData', {target: 'CALC_SUMM', value: saveSumm})
        }
      }
    },
  },
  methods:{
    goTo(index, $event){
      $event.preventDefault();
      window.scrollTo({
        left:0,
        top:document.getElementById(index).offsetTop - 100,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style scoped>
#amoutSelector{font-family: 'Roboto'; background: white; padding: var(--font-size-30) var(--font-size-49) var(--font-size-39); border-radius: var(--font-size-20)}
.amountLine{display: flex;align-items: center;justify-content: space-between;font-size: var(--font-size-16);font-weight: 500}
.frln{margin-bottom: var(--font-size-20)}
.frln p:last-child{color:var(--font-size-20);font-weight: 700;}
.clgra{color:var(--color-gray-type3);margin:var(--font-size-04) 0 var(--font-size-49)}
.clgr{margin: var(--font-size-20) auto}
.clgr p:last-child{color:var(--color-green)}
h3{font-size: var(--font-size-24);font-weight: 700;text-align: center;margin-bottom: var(--font-size-49)}
button{margin-top: var(--font-size-49)}

/deep/.slider { width: 100%;  padding: 0; }
/deep/.slider .range-slider-hidden { display: none; }
/deep/.slider .range-slider-rail { background-color: var(--color-green); }
/deep/.slider .range-slider-fill { background-color: var(--color-dark-green); }
/deep/.slider .range-slider-fill, .slider .range-slider-rail{height: var(--font-size-06);border-radius: var(--font-size-06);}
/deep/.slider .range-slider-knob{width: var(--font-size-30);height:var(--font-size-30);border-radius: var(--font-size-30);border:var(--font-size-04) solid var(--color-dark-green); background: var(--color-dark-green);box-shadow: inset 0 0 0 var(--font-size-04) white;}



@media screen and (min-width: 760px) {
  #amoutSelector{padding: var(--font-size-33) var(--font-size-30) var(--font-size-39);width: calc(var(--font-size-400) - (var(--font-size-30) * 2));
    box-shadow: var(--font-size-12) var(--font-size-08) var(--font-size-33) rgba(0, 0, 0, 0.1);}
}

</style>